import elementsOffset from 'modules/helpers/elementsOffset';
import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

export const productListTopPositionAtom = atom<number>({
    key: 'product-list-top-position',
    default: 0
});

export default function useProductListTopPosition() {
    const productListTopPosition = useRecoilValue(productListTopPositionAtom);

    return productListTopPosition;
}

export function useSetProductListTopPosition() {
    const set = useSetRecoilState(productListTopPositionAtom);

    const setProductListTopPosition = (node) => {
        if (!node) return null;
        set(elementsOffset(node)?.top);
    };

    return setProductListTopPosition;
}
